import React from 'react';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../constants';

const InsuranceDevice = ({ device }) => {
  return (
    <div>
      <table className="table">
        <tbody>
          <tr>
            <td>Device ID</td>
            <td>{device.id}</td>
          </tr>
          <tr>
            <td>Contract ID</td>
            <td>{device.contract}</td>
          </tr>
          <tr>
            <td>Device Specs</td>
            <td>{device.device_specs}</td>
          </tr>
          <tr>
            <td>Plan ID</td>
            <td>{device.plan}</td>
          </tr>
          <tr>
            <td>Condition</td>
            <td>{device.condition}</td>
          </tr>
          <tr>
            <td>Purchase Date</td>
            <td>{device.purchase_date}</td>
          </tr>
          <tr>
            <td>Replacement</td>
            <td>{device.is_replacement ? 'Yes' : 'No'}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>{device.status}</td>
          </tr>
          <tr>
            <td>Active</td>
            <td>{device.active}</td>
          </tr>
          <tr>
            <td>Created Date</td>
            {device.created_at ? (
              <td>{moment(device.created_at).format(DATE_TIME_FORMAT)}</td>
            ) : (
              <td></td>
            )}
          </tr>
          <tr>
            <td>Activation Date</td>
            {device.activated_at ? (
              <td>{moment(device.activated_at).format(DATE_TIME_FORMAT)}</td>
            ) : (
              <td></td>
            )}
          </tr>
          <tr>
            <td>Last Updated</td>
            {device.updated_at ? (
              <td>{moment(device.updated_at).format(DATE_TIME_FORMAT)}</td>
            ) : (
              <td></td>
            )}
          </tr>
          <tr>
            <td>Expiry Date</td>
            {device.expiry_date ? (
              <td>{moment(device.expiry_date).format(DATE_TIME_FORMAT)}</td>
            ) : (
              <td></td>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default InsuranceDevice;
